// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reason-table-tree .p-treetable-thead {\n  display: none !important;\n}\n.p-treetable .p-treetable-tbody > tr > td {\n  border: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
